module.exports = __webpack_public_path__ + "static/img/3115-01.1a20241d.jpg";